import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulbSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLightBulbSimple"><Path d="M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 12.9113 18.4443 15.4582 16.1237 16.8565C16.0827 16.8812 16.0415 16.9056 16 16.9296V17H8V16.9296C7.95853 16.9056 7.9173 16.8812 7.87631 16.8565C5.55568 15.4582 4 12.9113 4 10Z" fill="currentColor"/><Path d="M8 19C8 21.2091 9.79086 23 12 23C14.2091 23 16 21.2091 16 19H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightBulbSimple;
